import { useEffect } from "react";
import { useHistory } from "react-router-dom"
import Alert from "../../../../itrust_common/components/Alert";

export const useSelectStoreHook = (redirectTo) => {
  const history = useHistory()

  useEffect(() => {
    if (localStorage.getItem("StoreID") == null) {
      Alert.warning("Please select a store from the top dropdown.", (res) => {
        if (res && redirectTo) {
          history.push(redirectTo);
        }
      });
    }
  });
};
